import React from "react";
import classNames from "classnames/bind";

import styles from "./IconDotLoader.module.css";

const cx = classNames.bind(styles);

export const IconDotLoader: React.FC<{}> = () => (
  <span className={cx("iconDotLoader")}>
    <span className={cx("dot")} />
    <span className={cx("dot")} />
    <span className={cx("dot")} />
  </span>
);
